<div class="page-header page-header--blue clearfix">
  <h1 class="page-header__title">Account Dashboard</h1>
  <ab-time-dur-switch
    class="page-header__element"
    [enabled]="enabled"
    [dur]="dur"
    [lastN]="lastN"
    (changed)="onDurChange($event)"
  ></ab-time-dur-switch>
  <div class="page-header__on-right">
    <a
      class="btn btn--primary float-md-right"
      href="/users/{{ user.id }}/edit?project_modal=1"
      *ngIf="user.admin"
      target="_self"
      >Add new project</a
    >
  </div>
</div>
<div class="alerts-container">
  <ab-alerts-common></ab-alerts-common>
</div>
<div class="flex-grow-1 content-mask-container">
  <div class="content-mask" *ngIf="featureDisabled">
    <div class="content-mask__content">
      <p class="content-mask__text">
        This Dashboard is showing sample data. Enable the Account Dashboard to
        see an overview of all your projects with detailed analytics.
      </p>
      <button
        class="btn btn--upgrade"
        (click)="openUpgradeModal($event)"
        data-feature="account_dashboard"
        type="button"
      >
        Enable Account Dashboard
      </button>
    </div>
  </div>
  <div class="d-flex justify-content-md-center" *ngIf="showSingleProjectAlert">
    <div class="col-md-6 col-lg-4">
      <ngb-alert
        class="info-box text-center"
        type=""
        *ngIf="showSingleProjectAlert"
        (closed)="closeSingleProjectAlert()"
      >
        <h1 class="info-box__title">Airbrake tip!</h1>
        <p class="info-box__text">
          Monitor more projects to see account-wide statistics
        </p>
        <a
          class="btn btn--primary"
          href="/users/{{ user.id }}/edit?project_modal=1"
          target="_self"
          >Add new project</a
        >
      </ngb-alert>
    </div>
  </div>
  <div class="clearfix pt-3">
    <div class="col-lg-12">
      <ab-account-projects
        [dur]="dur"
        [lastN]="lastN"
        (loadingChanged)="onLoading($event)"
        [user]="user"
        [featureDisabled]="featureDisabled"
        [hasNoErrors]="hasNoErrors"
        [hasNoDeploys]="hasNoDeploys"
        [hasNoRequests]="hasNoRequests"
      ></ab-account-projects>
    </div>
  </div>
</div>
